import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import type { NapiClient } from "@app/services/api";
import type { ResultStateCommon } from "@app/types/results-redux-types";

import { OPERATOR_PROFILE_REVIEWS_STATUS } from "../constants/profile-reviews";
import { getProfileReviews } from "../services/profile-reviews";

interface fetchOperatorRatingParams {
  api: NapiClient;
  profile_id: number;
}

export const fetchProfileReviews = createAsyncThunk(
  "fetch_operator_profile_reviews",
  async ({ api, profile_id }: fetchOperatorRatingParams, {}) => {
    const profile_reviews = await getProfileReviews(api, profile_id);
    return { profile_id, profile_reviews };
  }
);

const operatorProfileReviews = createSlice({
  name: "operator_profile_reviews",
  initialState: {} as ResultStateCommon["operator_profile_reviews"],
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchProfileReviews.pending, (state, action) => {
      state[action.meta.arg.profile_id] = {
        reviews: [],
        status: OPERATOR_PROFILE_REVIEWS_STATUS.PENDING,
        error: null
      };
    });
    builder.addCase(fetchProfileReviews.fulfilled, (state, action) => {
      state[action.meta.arg.profile_id] = {
        reviews: action.payload.profile_reviews ?? [],
        status: OPERATOR_PROFILE_REVIEWS_STATUS.SUCCEEDED,
        error: null
      };
    });
    builder.addCase(fetchProfileReviews.rejected, (state, action) => {
      state[action.meta.arg.profile_id] = {
        reviews: [],
        status: OPERATOR_PROFILE_REVIEWS_STATUS.FAILED,
        error: action.error
      };
    });
  }
});

export default operatorProfileReviews.reducer;
